import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorFallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // IS-3401 => Disable generic error page
    // const pathParts = window.location.pathname?.split('/');
    // const lastPath = pathParts[pathParts?.length - 1];
    // if (lastPath == 'create-document' || lastPath == 'episode-caredetails') {
    //   return navigate('/document-error');
    // }

    return navigate('/error');
  }, []);

  return <></>;
};

export default ErrorFallback;
